module.exports = "<simple-notifications [options]=\"options\" (onCreate)=\"onCreate($event)\" (onDestroy)=\"onDestroy($event)\">\n</simple-notifications>\n\n<footer class=\"footer\">\n\t<div class=\"container\">\n    <ul class=\"text-muted\">\n      <li>{{domain.platformName}}</li>\n      <li>Powered By <a href=\"https://www.leapest.com/\" target=\"_blank\" rel=\"noopener noreferrer\">Leapest</a></li>\n      <li><a routerLink=\"/privacy\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a></li>\n    </ul>\n\t</div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/partials/footer/footer.component.html
// module id = 903
// module chunks = 0